import React from 'react'
import Layout from './src/layouts/index.js'

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}